<template>
  <div class="containers">
    <!-- 更改浏览器标题 -->
    <!-- <div class="main" v-title data-title="首页">
    </div> -->
    <!-- 轮播 -->
    <Swiper></Swiper>
    <!-- 主体 -->
    <!-- <div class="diolog"></div>
    <div class="kjsfal other_1" id="kjsfal">
      <div class="kjsfalTop">
        <p class="m_con wow fadeInLeft groupl">
          <img src="../assets/imgs/首页/25.jpg" alt="" />
        </p>
        <div class="m_con wow fadeInRight">
          <h4><p>企业概括</p>
          <span>/ABOUT GROUP</span></h4>
          <p
            style="
              font-size: 28px;
              color: #fff;
              font-weight: 700;
              margin: 40px 0;
            "
          >
            {{ $t('home.1-1') }}
          </p>
          <img src="../assets/imgs/首页/08.png" alt="" class="imageWidth"/>
          <div class="thrh">
            <img src="../assets/imgs/首页/09.png" alt="" class="imgWidth"/>
            <p>DETAILS</p>
          </div>
        </div>
      </div>
      <p class="kjsfalBtm wow slideInUp">
        <ul>
          <li>
            <h3>2001<span>{{ $t('home.1-2') }}</span></h3>
            <p>
              {{ $t('home.1-3') }}
            </p>
          </li>
          <li>
            <h3>2009<span>{{ $t('home.1-2') }}</span></h3>
            <p>
             {{ $t('home.1-4') }}
            </p>
          </li>
          <li>
            <h3>2014<span>{{ $t('home.1-2') }}</span></h3>
            <p>
              {{ $t('home.1-5') }}
            </p>
          </li>
          <li>
            <h3>2015<span>{{ $t('home.1-2') }}</span></h3>
            <p>
              {{ $t('home.1-6') }}
            </p>
          </li>
          <li>
            <h3>2017<span>{{ $t('home.1-2') }}</span></h3>
            <p>
              {{ $t('home.1-7') }}
            </p>
          </li>
          <li>
            <h3>2021<span>{{ $t('home.1-2') }}</span></h3>
            <p>
             {{ $t('home.1-8') }}
            </p>
          </li>
        </ul>
      </p>
    </div> -->
    <!-- 海报 -->
    <!-- <div class="ban">
      <div class="banner other_2">
      <div class="">
        <p><img src="../assets/imgs/首页/12.png" alt=""></p>
        <div class="bannerL">
          <h3>
           {{ $t('home.2-1') }}
          </h3>
          <p class="hengx"></p>
          <p class="p-line">
            {{ $t('home.2-2') }}
          </p>
        </div>
        <div class="bannerR">
          <img src="../assets/imgs/首页/30.png" alt="">
          <p class="p1" @click="jump(1)"></p>
          <p class="p2" @click="jump(2)"></p>
          <p class="p3" @click="jump(3)"></p>
        </div>
      </div>
    </div>
    </div> -->
    <!-- 新闻 -->
    <div class="products wow bounceInLeft">
      <!-- <h2>新闻中心<span>/OUR PRODUCTS</span></h2> -->
      <div class="productsBox">
        <!-- 左侧 -->
        <div class="productsLeft other_3" @click="details(newslist[0])">
          <div class="topBox">
            <img v-if="newslist[0]" :src="newslist[0].coverImg" alt="">
          </div>
          <div class="bomBox">
            <h4 v-if="newslist[0]">{{newslist[0].title}}</h4>
            <p v-if="newslist[0]" v-html="newslist[0].content">
            </p>
          </div>
        </div>
        <!-- 新闻类别 -->
        <div class="productsRight">
          <div class="choice">
            <ul>
              <li :class="newsType == 1?'active':''" @click="newstype(1)">{{ $t('home.3-1') }}</li>
              <li :class="newsType == 2?'active':''" @click="newstype(2)">{{ $t('home.3-2') }}</li>
              <!-- <li :class="newsType == 3?'active':''" @click="newstype(3)">{{ $t('home.3-3') }}</li>
              <li :class="newsType == 4?'active':''" @click="newstype(4)">{{ $t('home.3-4') }}</li> -->
            </ul>
            <!-- 查看更多 -->
            <p @click="toNews()">{{ $t('home.3-5') }}  &gt;</p>
          </div>
          <!-- 右侧 -->
          <ul class="list">
            <li v-if="newslist[1]"  @click="details(newslist[1])">
              <div class="listL" :style="{backgroundImage:'url('+newslist[1].coverImg+')'}">
                 {{FormatTime(newslist[1].addDate)}}-{{FormatTimeDD(newslist[1].addDate)}}
              </div>
              <div class="listR">
                <h4>{{newslist[1].title}}</h4>
                <p v-html="newslist[1].content">
                </p>
              </div>
            </li>
            <li v-if="newslist[2]"  @click="details(newslist[2])">
              <div class="listL" :style="{backgroundImage:'url('+newslist[2].coverImg+')'}">
                 {{FormatTime(newslist[2].addDate)}}-{{FormatTimeDD(newslist[2].addDate)}}
              </div>
              <div class="listR">
                <h4>{{newslist[2].title}}</h4>
                <p v-html="newslist[2].content">
                </p>
              </div>
            </li>
            <li v-if="newslist[3]"  @click="details(newslist[3])">
              <div class="listL" :style="{backgroundImage:'url('+newslist[3].coverImg+')'}">
               {{FormatTime(newslist[3].addDate)}}-{{FormatTimeDD(newslist[3].addDate)}} 
              </div>
              <div class="listR">
                <h4>{{newslist[3].title}}</h4>
                <p v-html="newslist[3].content">
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 荣誉 -->
  </div>
</template>
<script>
import { newList } from '@/api/index.js'
import Swiper from './components/swiper.vue'
import { WOW } from 'wowjs'
export default {
  data() {
    return {
      newslist: {},
      newsType: null,
      detailsList: [],
      lang: '',
      type: 1
    }
  },
  beforeDestroy() {
    // window.removeEventListener('mousewheel', this.WheelGo)
    // console.log(123)
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      const wow = new WOW({
        live: false
      })
      wow.init()
      // this.WheelGo()
    })
    this.new()
    this.$bus.$on('lang', (lang) => {
      this.type = lang
      this.new()
    })
  },
  methods: {
    toNews() {
      this.$router.push('/news')
    },
    newstype(a) {
      this.newsType = a
      this.new()
    },
    async details(i) {
      this.$router.push({
        path: '/newDetails',
        query: {
          code: JSON.stringify(i.id)
        }
      })
    },
    FormatTime(time) {
      if (time) {
        var date = new Date(time)
        var YY = date.getFullYear() + '-'
        var MM =
          date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1)
            : date.getMonth() + 1
        return YY + MM
      }
    },
    FormatTimeDD(time) {
      if (time) {
        var date = new Date(time)
        var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        return DD
      }
    },
    jump(e) {
      // alert(e)
    },
    async new() {
      console.log(this.$i18n.locale)
      setTimeout(async () => {
        if (this.$i18n.locale === 'zh') {
          this.type = 1
        } else {
          this.type = 2
        }
        if (this.type === 'zh' || this.type === 1) {
          this.type = 1
        } else {
          this.type = 2
        }
        const { data } = await newList({
          pageNum: 1,
          pageSize: 4,
          newsType: this.newsType,
          language: this.type
        })
        this.newslist = data.list
      })
    }
  },
  watch: {
    type() {
      if (this.$i18n.locale === 'zh') {
        this.type = 1
      }
    }
  },
  components: {
    Swiper
  }
}
</script>
<style lang="less" scoped>
.containers {
  box-sizing: border-box;
  min-width: 1920px;
  background-color: #112945;
  // max-width: 100%;
  // @media screen and (max-width: 760px) {
  //   width: 100%;
  //   min-width: 100%;
  //   // padding-top: 60px;
  // }

  /deep/.today .cell {
    color: #333 !important;
    font-weight: 500 !important;
  }
  .diolog {
    width: 100%;
    height: calc(100vh - 120px);
    padding-top: 120px;
    @media screen and (max-width: 1200px) {
      height: calc(30vh - 140px);
      padding-top: 140px;
    }
  }
  // 轮播
  .swiper {
    width: 100%;
    height: calc(100vh - 5px);
    background-color: #15518d;
    padding-top: 0px;
    @media screen and (max-width: 1920px) {
      height: calc(100vh - 5px);
      padding-top: 0px;
    }
    @media screen and (max-width: 1200px) {
      height: calc(100vh - 5px);
      padding-top: 0px;
    }
    .el-carousel {
      height: 100%;
      /deep/.el-carousel__container {
        height: 100%;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    // .swiper-slide {
    //   width: 100%;
    //   font-size: 50px;
    //   text-align: center;
    // }
    // .swiper-pagination {
    //   .swiper-pagination-bullet {
    //     width: 30px;
    //     height: 2px;
    //     cursor: pointer;
    //     background-color: #fff;
    //     border-radius: 0;
    //   }
    // }
  }

  // 主体
  .kjsfal {
    // text-align: center;
    padding: 60px 0;
    margin: 0px auto;
    // height: 100vh;
    // padding: 0px 0 100px 0;
    position: relative;
    z-index: 3;
    // background-color: #112945;
    // @media screen and (max-width: 475px) {
    //   padding: 35px 0 60px 0;
    // }
    .kjsfalTop {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .fadeInRight{
        width: 600px;
        .imageWidth {
          width: 600px;
        }
      }
      h4 {
        font-size: 36px;
        font-weight: 700;
        color: #fff;
        position: relative;
        p {
          font-weight: 700;
          position: absolute;
          top: -24px;
        }
        span {
          color: #5699e6;
          font-weight: 700;
          text-shadow: 0 0 1px white;
        }
      }
    }
    .kjsfalBtm {
      margin: 0px auto;
      padding: 70px 0;
      width: 1200px;
      ul {
        display: flex;
        justify-content: space-between;
         @media screen and (max-width: 1200px) {
            flex-flow: wrap;
          }
        li {
          width: 190px;
          min-height: 135px;
          text-align: center;
          border: 1px solid #ccc;
          padding: 15px;
          box-sizing: border-box;
          cursor: pointer;
          transition: All 0.4s ease-in-out;
          @media screen and (max-width: 1200px) {
            width: 380px;
            height: 160px;
            margin-bottom: 15px;
          }
          &:hover {
            background-color: #1a3a5a;
            transform: scale(1.08);
            h3 {
              font-size: 54px;
              color: #fff;
              font-weight: 700;
              line-height: 56px;
              span {
                font-size: 16px;
                color: #fff;
              }
            }
            p {
              font-size: 12px;
              line-height: 18px;
              color: #fff;
            }
          }
          h3 {
            font-size: 54px;
            color: #fff;
            font-weight: 700;
            line-height: 56px;
            span {
              font-size: 16px;
              color: #fff;
            }
          }
          p {
            font-size: 12px;
            line-height: 18px;
            color: #fff;
            @media screen and (max-width: 1200px) {
              font-size: 18px;
              line-height: 1.5;
            }
          }
        }
      }
    }
    .groupl {
      margin-right: 126px;
      width: 400px;
      height: 380px;
      overflow: hidden;
      img {
        width: 400px;
        height: 400px;
        transition: All 0.4s ease-in-out;
        &:hover {
          transform: rotate(3deg) scale(1.08);
        }
      }
    }
    .groupr {
      height: 70px;
    }
    .jianjie {
      font-size: 18px;
      color: #999;
      line-height: 26px;
      text-indent: 2em;
      margin: 30px 0;
    }
    .thrh {
      position: relative;
      margin: 70px 0 0px 0;
      p {
        position: absolute;
        top: 72px;
        left: 26px;
        color: #fff;
      }
    }
  }
  .ban {
    // padding-top: 200px;
    // height: 100vh;
    box-sizing: border-box;
    // background-color: #112945;
    background-image: linear-gradient(to bottom right,#6495ED, #112945);
    position: relative;
    z-index: 3;
  }
  .banner {
    width: 100%;
    height: 380px;
    background-image: url(../assets/imgs/首页/13.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    > div {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      > p {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translate(-50%);
      }
    }

    .bannerL {
      flex: 520px 0 0;
      margin-top: 80px;
      h3 {
        font-size: 26px;
        color: #fff;
      }
      p {
        font-size: 12px;
        color: #e0e0e0;
        margin-top: 30px;
        line-height: 30px;
        @media screen and (max-width: 1200px) {
          font-size: 20px;
        }
      }
      .hengx {
        width: 44px;
        height: 4px;
        background-color: #fff;
      }
    }
    .bannerR {
      margin-top: 30px;
      position: relative;
      img {
        width: 550px;
        height: 315px;
      }
      p {
        width: 150px;
        height: 80px;
        // background-color: #fff;
        position: absolute;
        cursor: pointer;
      }
      .p1 {
        top: 47px;
        right: 78px;
      }
      .p2 {
        top: 137px;
        right: 3px;
      }
      .p3 {
        top: 230px;
        right: 78px;
      }
    }
  }
  //新闻
  .products {
    background: url("../assets/imgs/tianhaiBg.jpg");
    // background-color: #112945;
    // background: linear-gradient(to bottom, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);
    //  background-image: linear-gradient(to right,#112945 70%,#6495ED);
    margin: 0px auto;
    padding-top: 50px;
    // height: 100vh;
    // box-sizing: border-box;
    padding-bottom: 250px;
    position: relative;
    z-index: 3;
    background-color: #112945;
    // padding-top: 200px;
    // display: flex;
    /deep/.newsBox {
      img {
        width: 510px !important;
        height: 360px !important;
      }
      p {
      }
    }
    h2 {
      text-align: center;
      padding: 155px 0 90px 0;
      font-size: 44px;
      color: #fff;
      span {
        color: #979ba2;
        font-size: 30px;
      }
    }
    .productsBox {
      width: 1200px;
      display: flex;
      margin: 0px auto;
      .productsLeft {
        width: 510px;
        .topBox {
          width: 510px;
          height: 360px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            transition: All 0.4s ease-in-out;
            &:hover {
              transform: scale(1.03);
            }
          }
        }
        .bomBox {
          width: 510px;
          height: 120px;
          background-color: #18304b;
          padding: 10px;
          box-sizing: border-box;
          @media screen and (max-width: 1200px) {
            height: 200px;
          }
          /deep/img {
            width: 0px !important;
            height: 0px !important;
          }
          h4 {
            font-size: 23px;
            font-weight: 700;
            line-height: 32px;
            color: rgb(248, 247, 247);
          }
          p {
            font-weight: 700;
            font-size: 14px; 
            color: #ffffff;
            line-height: 20px;
            display: -webkit-box;
            -webkit-box-orient: vertical; /*设置方向*/
            -webkit-line-clamp: 1; /*设置超过为省略号的行数*/
            overflow: hidden;
          }
        }
      }
      .productsRight {
        width: 720px;
        margin-left: 15px;
        .choice {
          display: flex;
          position: relative;
          ul {
            display: flex;
            li {
              width: 115px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #fff;
              border: 0px solid #112945;
              font-weight: 700;
              margin-right: 12px;
              background-color: #112945;
              cursor: pointer;
              border-radius: 3px;
              @media screen and (max-width: 1200px) {
                width: 160px;
                height: 60px;
                line-height: 60px;
              }
              &.active {
                background-color: #112945;
              }
              &:hover {
                background-color: #41556b;
              }
            }
          }
          > p {
            position: absolute;
            right: 0;
            width: 120px;
            height: 36px;
            background-color: #112945;
            line-height: 36px;
            text-align: center;
            font-weight: 700;
            color: #fffdfd;
            cursor: pointer;
            border-radius: 5px;
              @media screen and (max-width: 1200px) {
                width: 200px;
                height: 60px;
                line-height: 60px;
              }
          }
        }
        .list {
          li {
            display: flex;
            margin-top: 13px;
            .listL {
              position: relative;
              width: 160px;
              height: 130px;
              line-height: 230px;
              color: #fff;
              font-size: 16px;
              text-align: center;
              background-size: 100%;
              cursor: pointer;
              transition: All 0.4s ease-in-out;
              background-repeat: no-repeat!important;
              background-size: cover;
              &:hover {
                transform: scale(1.08);
              }
              p {
                position: absolute;
                bottom: 0;
                width: 160px;
                width: 100%;
                height: 26px;
                line-height: 26px;
                font-size: 20px;
                background-color: rgba(0, 0, 0, 0.2);
                color: #fff;
                z-index: 99;
              }
            }
            .listR {
              background-color: #18304b;
              padding: 15px 25px 0 15px;
              width: 560px;
              box-sizing: border-box;
              cursor: pointer;
              h4 {
                font-size: 21px;
                color: #fff;
                line-height: 24px;
                @media screen and (max-width: 1200px) {
                  font-size: 24px;
                }
              }
              > p {
                font-size: 13px;
                font-weight: 700;
                line-height: 24px;
                color: #ffffff;
                margin-top: 10px;
                display: -webkit-box;
                -webkit-box-orient: vertical; /*设置方向*/
                -webkit-line-clamp: 1; /*设置超过为省略号的行数*/
                overflow: hidden;
                display: -o-box;
                display: -moz-box;
                -o-box-orient: vertical; /*设置方向*/
                -o-line-clamp: 1; /*设置超过为省略号的行数*/
                -moz-box-orient: vertical; /*设置方向*/
                -moz-line-clamp: 1; /*设置超过为省略号的行数*/
                box-orient: vertical; /*设置方向*/
                line-clamp: 1; /*设置超过为省略号的行数*/
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
  .honor {
    width: 1200px;
    margin: 0 auto;
    // margin-top: 400px;
    margin-bottom: 100px;
    img {
      width: 100%;
    }
  }
  // 页脚
  .footer {
    background-color: #2c374a;
    .wrapper {
      width: 1400px;
      height: 380px;
      box-sizing: border-box;
      padding-top: 110px;
      padding-left: 40px;
      margin: 0 auto;
      display: flex;
      position: relative;
      .shuxian {
        width: 2px;
        height: 128px;
        background-color: #404a5c;
        margin: 0 72px;
      }
      .logo2 {
        width: 128px;
        height: 45px;
        margin: 24px 90px 0 0;
      }
      ul {
        h4 {
          font-size: 16px;
          color: #e0e1e3;
          margin-bottom: 10px;
        }
        li {
          font-size: 14px;
          color: #979ba2;
          margin: 12px 0;
        }
      }
      > div {
        color: white;
        display: flex;
        text-align: center;
        margin-left: 100px;
        font-size: 18px;
        div {
          margin-left: 25px;
          .ewm {
            width: 110px;
            height: 110px;
            background-color: #fff;
            margin: 5px 0;
          }
          span {
            font-size: 14px;
            color: #979ba2;
          }
        }
      }
    }
    .bottom {
      line-height: 60px;
      text-align: center;
      background-color: #1d242f;
      color: #e0e1e3;
      font-size: 14px;
    }
  }

  // 浮窗
  .pcfc {
    position: fixed;
    right: 10px;
    top: 50%;
    background-color: rgb(42, 193, 212);
    z-index: 999999;
    ul {
      font-size: 16px;
      li {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        &:hover div {
          opacity: 1;
          transform: translateX(-50px);
        }
        img {
          width: 45px;
          height: 45px;
          z-index: 2;
        }
        div {
          position: absolute;
          top: 0;
          left: -50px;
          text-align: center;
          height: 50px;
          line-height: 50px;
          opacity: 0;
          font-size: 14px;
          font-weight: 700;
          width: 100px;
          background-color: rgb(42, 193, 212);
          color: #fff;
          transition: all 0.5s;
        }
      }
    }
  }

  .imgWidth {
    width: 560px;
    height: 152px;
  }
}
</style>
